import { render, staticRenderFns } from "./detailTorrent.vue?vue&type=template&id=26ee799c&scoped=true&"
import script from "./detailTorrent.vue?vue&type=script&lang=js&"
export * from "./detailTorrent.vue?vue&type=script&lang=js&"
import style0 from "./detailTorrent.vue?vue&type=style&index=0&id=26ee799c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ee799c",
  null
  
)

export default component.exports